import { d as g, m as C, g as c } from "./index-E8vB_04G.js";
import { l as R } from "./index-b-LDu0Rp.js";
import "./nacl-fast-DmSj04OB.js";
import { b as w, a as m, f, r as E } from "./utils-dinPOBnH.js";
import { Compiler as S } from "ddc";
import "sgx-ias-verifier";
import "./config.js";
import "./index-Buti0PLx.js";
import "./index-jyncyKHm.js";
import "./index-Ch-rSMgZ.js";
const O = 6, T = 1;
function b(v) {
  if (v.dataRoomId)
    return v.dataRoomId;
  throw v.dataRoomValidationError ? new Error(
    `Data room creation failed: '${v.dataRoomValidationError.message}'`
  ) : new Error(
    `Unknown response structure for CreateDataRoomResponse: ${v}`
  );
}
class y {
  client;
  // This field is shared across channel and connection
  auth;
  /**
   * High-level representation compiler.
   */
  compiler;
  clientProtocols;
  channel;
  metaData;
  constructor(s, r, o, n, i, e) {
    this.auth = s, this.client = r, this.clientProtocols = o, this.compiler = i, this.channel = e, this.metaData = {
      driverAttestationSpecificationHash: n,
      email: s.getUserId()
    };
  }
  static async create({
    client: s,
    driverAttestationSpecificationHash: r,
    clientProtocols: o,
    auth: n,
    connection: i
  }) {
    const e = await S.initialize();
    return new y(
      n,
      s,
      o,
      r,
      e,
      i
    );
  }
  /**
   * Create a data room with the provided protobuf configuration object
   * and have the enclave apply the given list of modifications to the data
   * room configuration.
   *
   * @returns An id that will be used when interacting with the
   * published data room (for example when running computations or publishing
   * datasets).
   */
  async publishDataRoom(s, r) {
    const o = await this.tryPublishDataRoom(s, r), n = b(o);
    return w(n);
  }
  async publishDataScienceDataRoom(s, r) {
    const o = this.compiler.compileDataScienceDataRoom(s), n = await this.tryPublishDataRoom(
      g.DataRoom.decodeDelimited(o.dataRoom),
      {
        ...r,
        dataRoomKind: C.CreateDcrKind.DATASCIENCE,
        highLevelDcrRepresentation: o.highLevel
      }
    );
    if (n.dataRoomValidationError)
      throw n.dataRoomValidationError;
    return w(n.dataRoomId);
  }
  async publishDataScienceCommit(s, r) {
    const o = this.compiler.compileDataScienceDataRoom(r), n = this.compiler.convertDataScienceCommitToMatchDataScienceDataRoomVersion(
      s,
      r
    ), i = this.compiler.compileDataScienceCommit(
      n,
      o.commitContext
    );
    return await this.publishDataRoomConfigurationCommit(
      g.ConfigurationCommit.decodeDelimited(i.commit),
      {
        highLevelCommitRepresentation: i.highLevel
      }
    );
  }
  async retrieveDataScienceCommit(s, r) {
    const { commit: o, highLevelRepresentation: n } = await this.retrieveConfigurationCommit(s), i = R.util.binary.hex.encode(
      o?.dataRoomHistoryPin
    ), e = JSON.parse(JSON.stringify(r));
    if ("v0" in e) {
      if (!("interactive" in e.v0))
        throw new Error("DataScience dataroom is not interactive");
      const a = e.v0.interactive.commits.findIndex(
        (l) => l.historyPin === i
      );
      a !== -1 && e.v0.interactive.commits.splice(a);
    } else if ("v1" in e) {
      if (!("interactive" in e.v1))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v2" in e) {
      if (!("interactive" in e.v2))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v3" in e) {
      if (!("interactive" in e.v3))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v4" in e) {
      if (!("interactive" in e.v4))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v5" in e) {
      if (!("interactive" in e.v5))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v6" in e) {
      if (!("interactive" in e.v6))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v7" in e) {
      if (!("interactive" in e.v7))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v8" in e) {
      if (!("interactive" in e.v8))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v9" in e) {
      if (!("interactive" in e.v9))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v10" in e) {
      if (!("interactive" in e.v10))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v11" in e) {
      if (!("interactive" in e.v11))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v12" in e) {
      if (!("interactive" in e.v12))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v13" in e) {
      if (!("interactive" in e.v13))
        throw new Error("DataScience dataroom is not interactive");
    } else if ("v14" in e) {
      if (!("interactive" in e.v14))
        throw new Error("DataScience dataroom is not interactive");
    } else
      throw new Error("Unsupported data room version");
    const t = this.compiler.compileDataScienceDataRoom(
      e
    );
    if (o && n)
      return this.compiler.verifyConfigurationCommit(
        g.ConfigurationCommit.encodeDelimited(o).finish(),
        n,
        t.commitContext
      );
    throw new Error("Missing high level representation");
  }
  async retrieveDataScienceDataRoom(s) {
    const { dataRoom: r, commits: o, highLevelRepresentation: n } = await this.retrieveDataRoom(s);
    if (r && o && n)
      return this.compiler.verifyDataRoom(
        g.DataRoom.encodeDelimited(r).finish(),
        o.map(
          (e) => g.ConfigurationCommit.encodeDelimited(e).finish()
        ),
        n
      );
  }
  async constructVerifiedDataScienceDataRoom(s) {
    const { dataRoom: r, commits: o, highLevelRepresentation: n } = s;
    if (r && o && n)
      return this.compiler.verifyDataRoom(
        g.DataRoom.encodeDelimited(r).finish(),
        o.map(
          (e) => g.ConfigurationCommit.encodeDelimited(e).finish()
        ),
        n
      );
  }
  /**
   * Internal method for attempting to publish a data room.
   * Users of the SDK should use [[`publishDataRoom`]].
   */
  async tryPublishDataRoom(s, r) {
    const o = [3, 4, 5, 6], n = m(this.clientProtocols, o), i = r?.dataRoomPurpose ?? C.CreateDcrPurpose.STANDARD, e = r?.dataRoomKind ?? C.CreateDcrKind.EXPERT, t = r?.showOrganizationLogo ?? !1, a = r?.requirePassword ?? !1, l = C.DcrMetadata.encodeDelimited({
      kind: e,
      purpose: i,
      requirePassword: a,
      showOrganizationLogo: t
    }).finish(), d = c.GcgRequest.create({
      createDataRoomRequest: {
        dataRoom: s,
        dataRoomMetadata: l,
        highLevelRepresentation: r?.highLevelDcrRepresentation
      }
    }), p = await this.sendRequest(d, n);
    if (p.length !== 1)
      throw new Error("Malformed response");
    const u = p[0];
    if (u.gcgResponse !== "createDataRoomResponse" || u.createDataRoomResponse === null || u.createDataRoomResponse === void 0)
      throw new Error(`Request failed, got ${u}`);
    return u.createDataRoomResponse;
  }
  /**
   * Publish the given data room configuration commit.
   *
   * Configuration commits can be built using a [[`DataRoomCommitBuilder`]] object.
   *
   * @returns The configuration commit id that will be used when running
   *   development computations or when trying to merge this commit into
   *   the main data room configuration.
   */
  async publishDataRoomConfigurationCommit(s, r) {
    const o = [3, 4, 5, 6], n = m(this.clientProtocols, o), i = c.CreateConfigurationCommitRequest.create({
      commit: s,
      highLevelRepresentation: r?.highLevelCommitRepresentation
    }), e = await this.sendRequest(
      c.GcgRequest.create({ createConfigurationCommitRequest: i }),
      n
    );
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.createConfigurationCommitResponse === null || t.createConfigurationCommitResponse === void 0)
      throw new Error(
        `Expected createConfigurationCommitResponse, got ${t}`
      );
    {
      const a = t.createConfigurationCommitResponse.commitId;
      if (a != null)
        return w(a);
      throw new Error(
        "Got undefined commit id in createConfigurationCommitResponse"
      );
    }
  }
  /**
   * Retrieve the content of the given configuration commit id.
   *
   * @returns A `ConfigurationCommit`.
   */
  async retrieveConfigurationCommit(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = c.RetrieveConfigurationCommitRequest.create({
      commitId: f(s)
    }), i = await this.sendRequest(
      c.GcgRequest.create({
        retrieveConfigurationCommitRequest: n
      }),
      o
    );
    if (i.length !== 1)
      throw new Error("Malformed response");
    const e = i[0], t = e.retrieveConfigurationCommitResponse;
    if (t == null)
      throw new Error(
        `Expected retrieveConfigurationCommitResponse, got ${e}`
      );
    if (t.commit !== void 0 && t.commit !== null)
      return t;
    throw new Error("Got undefined list of approvers");
  }
  /**
   * Retrieve the list of users who need to approve the merger of a given
   * configuration commit.
   *
   * @returns A list of ids belonging to the users that need to approve the
   *  configuration commit.
   */
  async retrieveConfigurationCommitApprovers(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = c.RetrieveConfigurationCommitApproversRequest.create({
      commitId: f(s)
    }), i = await this.sendRequest(
      c.GcgRequest.create({
        retrieveConfigurationCommitApproversRequest: n
      }),
      o
    );
    if (i.length !== 1)
      throw new Error("Malformed response");
    const e = i[0], t = e.retrieveConfigurationCommitApproversResponse;
    if (t == null)
      throw new Error(
        `Expected retrieveConfigurationCommitApproversResponse, got ${e}`
      );
    if (t.approvers !== void 0 && t.approvers !== null)
      return t.approvers;
    throw new Error("Got undefined list of approvers");
  }
  /**
   * Generate an approval signature required for merging a configuration commit.
   *
   * To merge a specific configuration commit, each user referenced in the list
   * of ids returned by [[`retrieveConfigurationCommitApprovers`]] needs to
   * generate an approval signature using this method.
   */
  async generateMergeApprovalSignature(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = c.GenerateMergeApprovalSignatureRequest.create({
      commitId: f(s)
    }), i = await this.sendRequest(
      c.GcgRequest.create({
        generateMergeApprovalSignatureRequest: n
      }),
      o
    );
    if (i.length !== 1)
      throw new Error("Malformed response");
    const e = i[0], t = e.generateMergeApprovalSignatureResponse;
    if (t == null)
      throw new Error(
        `Expected retrieveConfigurationCommitApproversResponse, got ${e}`
      );
    if (t.signature !== void 0 && t.signature !== null)
      return t.signature;
    throw new Error("Got undefined signature for merge approval");
  }
  /**
   * Request the enclave to merge the given configuration commit into the
   * main data room configuration.
   *
   * @param configurationCommitId - The id of the commit to be merged.
   * @param approvalSignatures - A map containing the approval signature for each
   *   of the required approvers, e.g. `{ "some@email.com": signature }`.
   */
  async mergeConfigurationCommit(s, r, o) {
    const n = [3, 4, 5, 6], i = m(this.clientProtocols, n), e = c.MergeConfigurationCommitRequest.create({
      approvalSignatures: r,
      commitId: f(s),
      newDataRoomHighLevelRepresentation: o?.newHighLevelDcrRepresentation
    }), t = await this.sendRequest(
      c.GcgRequest.create({
        mergeConfigurationCommitRequest: e
      }),
      i
    );
    if (t.length !== 1)
      throw new Error("Malformed response");
    const a = t[0], l = a.mergeConfigurationCommitResponse;
    if (l == null)
      throw new Error(
        `Expected mergeConfigurationCommitResponse, got ${a}`
      );
    return l;
  }
  /**
   * Retrieve the current data room confguration, as well as the current "history pin".
   *
   * A history pin is the hash of all the ids of configuration commits that
   * make up the structure of a data room. This pin therefore uniquely identifies
   * a data room's structure at a certain point in time.
   * A data room configuration, as well as its associated history pin, can be used
   * to extend an existing data room (for example by adding new compute nodes).
   * Extending an existing data room is done using the `DataRoomCommitBuilder` class.
   */
  async retrieveCurrentDataRoomConfiguration(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = c.RetrieveCurrentDataRoomConfigurationRequest.create({
      dataRoomId: f(s)
    }), i = await this.sendRequest(
      c.GcgRequest.create({
        retrieveCurrentDataRoomConfigurationRequest: n
      }),
      o
    );
    if (i.length !== 1)
      throw new Error("Malformed response");
    const e = i[0], t = e.retrieveCurrentDataRoomConfigurationResponse;
    if (t == null)
      throw new Error(
        `Expected retrieveCurrentDataRoomConfigurationResponse, got ${e}`
      );
    if (t.configuration && t.pin)
      return {
        dataRoomConfiguration: t.configuration,
        historyPin: w(t.pin)
      };
    throw new Error("Undefined config or history pin in response");
  }
  /**
   * Stop the data room with the given id, making it impossible to run new computations.
   */
  async stopDataRoom(s) {
    const r = await this.updateDataRoomStatus(
      s,
      c.DataRoomStatus.Stopped
    );
    return r != null;
  }
  /**
   * Update the status of the data room.
   * For the special case of stopping a data room, the method [[`Session.stopDataRoom`]]
   * can be used.
   */
  async updateDataRoomStatus(s, r) {
    const o = [3, 4, 5, 6], n = m(this.clientProtocols, o), i = R.util.binary.hex.decode(s), e = c.GcgRequest.create({
      updateDataRoomStatusRequest: {
        dataRoomId: i,
        status: r
      }
    }), t = await this.sendRequest(e, n);
    if (t.length !== 1)
      throw new Error("Malformed response");
    const a = t[0];
    if (a.gcgResponse !== "updateDataRoomStatusResponse" || a.updateDataRoomStatusResponse === null || a.updateDataRoomStatusResponse === void 0)
      throw new Error(`Request failed, got ${a}`);
    return a.updateDataRoomStatusResponse;
  }
  /**
   * Returns the status of the data room. Valid values are `"Active"` or `"Stopped"`.
   */
  async retrieveDataRoomStatus(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      retrieveDataRoomStatusRequest: {
        dataRoomId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse === "retrieveDataRoomStatusResponse" && t.retrieveDataRoomStatusResponse !== null && t.retrieveDataRoomStatusResponse !== void 0) {
      const a = t.retrieveDataRoomStatusResponse.status;
      if (a != null)
        return c.DataRoomStatus[a];
      throw new Error("Status not set on response");
    } else
      throw new Error(`Request failed, got ${t}`);
  }
  /**
   * Returns the underlying protobuf object for the data room.
   */
  async retrieveDataRoom(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      retrieveDataRoomRequest: {
        dataRoomId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse !== "retrieveDataRoomResponse" || t.retrieveDataRoomResponse === null || t.retrieveDataRoomResponse === void 0)
      throw new Error(`Request failed, got ${t}`);
    return t.retrieveDataRoomResponse;
  }
  /**
   * Returns the audit log for the data room.
   */
  async retrieveAuditLog(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      retrieveAuditLogRequest: {
        dataRoomId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse !== "retrieveAuditLogResponse" || t.retrieveAuditLogResponse === null || t.retrieveAuditLogResponse === void 0)
      throw new Error(`Request failed, got ${t}`);
    return t.retrieveAuditLogResponse;
  }
  /**
   * Publishes a file and its encryption key to a data room.
   * Neither the file or the encryption key will ever be stored in unencrypted form.
   * @param dataRoomId - Id of the data room to which the dataset should be published.
   * @param manifestHash - Id of the data set to publish. This id was usually obtained
   *   when uploading the dataset using [[`Client.uploadDataset`]].
   * @param leafId - Id of the data node to which the data should be uploaded.
   * @param key - Key with which the uploaded data was encrypted. This is the same key
   *   that was passed to [[`Client.uploadDataset`]].
   */
  async publishDataset(s, r, o, n) {
    const i = [3, 4, 5, 6], e = m(this.clientProtocols, i), t = R.util.binary.hex.decode(s), a = R.util.binary.hex.decode(r), l = await this.client.ensureDcrDataScope(s), d = c.GcgRequest.create({
      publishDatasetToDataRoomRequest: {
        dataRoomId: t,
        datasetHash: a,
        encryptionKey: n.material,
        leafId: o,
        scope: R.util.binary.hex.decode(l)
      }
    }), p = await this.sendRequest(d, e);
    if (p.length !== 1)
      throw new Error("Malformed response");
    const u = p[0];
    if (u.gcgResponse !== "publishDatasetToDataRoomResponse" || u.publishDatasetToDataRoomResponse === null || u.publishDatasetToDataRoomResponse === void 0)
      throw new Error(`Request failed, got ${u}`);
    return u.publishDatasetToDataRoomResponse;
  }
  /**
   * Removes a published dataset from the data room.
   * @param dataRoomId - Id of the data room from which dataset should be removed.
   * @param leafId - Id of the data node from which the data should be removed.
   */
  async removePublishedDataset(s, r) {
    const o = [3, 4, 5, 6], n = m(this.clientProtocols, o), i = R.util.binary.hex.decode(s), e = c.GcgRequest.create({
      removePublishedDatasetRequest: {
        dataRoomId: i,
        leafId: r
      }
    }), t = await this.sendRequest(e, n);
    if (t.length !== 1)
      throw new Error("Malformed response");
    const a = t[0];
    if (a.gcgResponse !== "removePublishedDatasetResponse" || a.removePublishedDatasetResponse === null || a.removePublishedDatasetResponse === void 0)
      throw new Error(`Request failed, got ${a}`);
    return a.removePublishedDatasetResponse;
  }
  /**
   * Returns the datasets published to the given data room.
   */
  async retrievePublishedDatasets(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      retrievePublishedDatasetsRequest: {
        dataRoomId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse !== "retrievePublishedDatasetsResponse" || t.retrievePublishedDatasetsResponse === null || t.retrievePublishedDatasetsResponse === void 0)
      throw new Error(`Request failed, got ${t}`);
    return t.retrievePublishedDatasetsResponse;
  }
  /**
   * Internal method for requesting the enclave to run a development
   * computation on top of a particular data room configuration.
   */
  async submitDevCompute(s, r, o, n = {}) {
    const i = [5, 6];
    n?.dryRun?.testDatasets || (i.push(3), i.push(4));
    const e = m(this.clientProtocols, i), t = await this.client.ensureDcrDataScope(s), a = !!n?.dryRun, l = {};
    for (const [D, q] of n?.dryRun?.testDatasets || [])
      l[D] = {
        encryptionKey: q.key.material,
        manifestHash: f(q.manifestHash)
      };
    const d = c.ExecuteDevelopmentComputeRequest.create({
      computeNodeIds: o,
      configurationCommitId: f(r),
      isDryRun: a,
      parameters: n?.parameters,
      scope: R.util.binary.hex.decode(t),
      testDatasets: l
    }), p = await this.sendRequest(
      c.GcgRequest.create({
        executeDevelopmentComputeRequest: d
      }),
      e
    );
    if (p.length !== 1)
      throw new Error("Malformed response");
    const u = p[0], h = u.executeComputeResponse;
    if (h == null)
      throw new Error(`Expected executeComputeResponse, got ${u}`);
    return h;
  }
  /**
   * Run a specific computation within the context of the data room configuration
   * defined by the given commit id.
   * Such "development" computations can also be run for configuration commits
   * that have not yet been merged.
   *
   * @param dataRoomId - The data room hash in the context of which to run the computation.
   * @param configurationCommitId - Id of the configuration commit on top of which the
   *   computation should be run.
   * @param computeNodeId - Name of the compute node specified when building the data room.
   * @returns An identifier object of the job executing the computation.
   *   This object is required for checking a job's status and retrieving its results.
   */
  async runDevComputation(s, r, o, n = {}) {
    const i = await this.submitDevCompute(
      s,
      r,
      [o],
      n
    );
    if (i.jobId !== void 0 && i.jobId !== null)
      return {
        computeNodeId: o,
        jobId: w(i.jobId)
      };
    throw new Error("Got undefined job id when running dev computation");
  }
  /**
   * Submits a computation request which will generate an execution plan to
   * perform the computation of the goal nodes.
   * Users of the SDK might want to use the convenience methods
   * [[`Session.runComputation`]] or [[`Session.runComputationAndGetResults`]].
   */
  async submitCompute(s, r, o = {}) {
    const n = [5, 6];
    o?.dryRun?.testDatasets || (n.push(3), n.push(4));
    const i = m(this.clientProtocols, n), e = R.util.binary.hex.decode(s), t = await this.client.ensureDcrDataScope(s), a = !!o?.dryRun, l = {};
    for (const [h, D] of o?.dryRun?.testDatasets || [])
      l[h] = {
        encryptionKey: D.key.material,
        manifestHash: f(D.manifestHash)
      };
    const d = c.GcgRequest.create({
      executeComputeRequest: {
        computeNodeIds: r,
        dataRoomId: e,
        isDryRun: a,
        scope: R.util.binary.hex.decode(t),
        testDatasets: l
      }
    }), p = await this.sendRequest(d, i);
    if (p.length !== 1)
      throw new Error("Malformed response");
    const u = p[0];
    if (u.gcgResponse !== "executeComputeResponse" || u.executeComputeResponse === null || u.executeComputeResponse === void 0)
      throw new Error(`Request failed, got ${u}`);
    return u.executeComputeResponse;
  }
  /**
   * Get the status of the provided `jobId` which will include the names of the nodes that
   * completed their execution.
   */
  async getComputationStatus(s) {
    const r = [3, 4, 5, 6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      jobStatusRequest: {
        jobId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse !== "jobStatusResponse" || t.jobStatusResponse === null || t.jobStatusResponse === void 0)
      throw new Error(`Request failed, got ${t}`);
    return t.jobStatusResponse;
  }
  async *streamJobResultsInner(s, r) {
    const o = [3, 4, 5, 6], n = m(this.clientProtocols, o), i = c.GcgRequest.create({
      getResultsRequest: {
        computeNodeId: r,
        jobId: s
      }
    }), e = await this.sendRequest(i, n);
    for (const t of e)
      switch (t.gcgResponse) {
        case "getResultsResponseChunk": {
          if (t.getResultsResponseChunk === null || t.getResultsResponseChunk === void 0)
            throw new Error(`Request failed, got ${t}`);
          yield t.getResultsResponseChunk;
          break;
        }
        case "getResultsResponseFooter":
          return;
        default:
          throw new Error(`Request failed, got ${t}`);
      }
    throw new Error("Enclave connection aborted while streaming results");
  }
  /**
   * Streams the results of the provided `jobId`.
   */
  async *streamJobResults(s, r) {
    yield* this.streamJobResultsInner(s, r);
  }
  /**
   * Get the results of the provided `jobId`.
   * Users of the SDK might want to use the convenience method
   * [[`Session.getComputationResult`]].
   */
  async getJobResults(s, r) {
    const o = E.withSize(1e3);
    for await (const n of this.streamJobResults(s, r)) {
      if (n.data === null || n.data === void 0)
        throw new Error("Invalid data chunk");
      o.extend(n.data);
    }
    return o.view();
  }
  /**
   * Get the results of the provided `jobId`.
   * Users of the SDK might want to use the convenience method
   * [[`Session.getComputationResultSize`]].
   */
  async getJobResultsSize(s, r) {
    const o = [6], n = m(this.clientProtocols, o), i = c.GcgRequest.create({
      getResultsSizeRequest: {
        computeNodeId: r,
        jobId: s
      }
    }), e = await this.sendRequest(i, n);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0];
    if (t.gcgResponse !== "getResultsSizeResponse" || t.getResultsSizeResponse === null || t.getResultsSizeResponse === void 0)
      throw new Error(`Request failed, got ${t}`);
    return t.getResultsSizeResponse.sizeBytes;
  }
  /**
   * Run a specific computation within the data room with the given id.
   *
   * @param dataRoomId - Id of the data room in which the computation should be run.
   * @param computeNodeId - Name of the compute node specified when building the data room.
   * @returns An identifier object of the job executing the computation.
   *   This object is required for checking a job's status and retrieving its results.
   */
  async runComputation(s, r, o = {}) {
    const n = await this.submitCompute(
      s,
      [r],
      o
    );
    if (n.jobId !== void 0 && n.jobId !== null) {
      const i = R.util.binary.hex.encode(n.jobId);
      return { computeNodeId: r, jobId: i };
    } else
      throw new Error("Received empty job id when submitting computation");
  }
  /**
   * Wait for the given job to complete and retrieve its results as a raw byte string.
   *
   * The method will check for the job's completeness every 5 seconds and up to
   * an optional maximum duration after which the method will raise an exception.
   * These values can be specified using the argument of type
   * [[`GetComputationResultsOptions`]].
   *
   * If the job completes and the results can be retrieved successfully, a raw byte string
   * will be returned. The bytes tring can be transformed into a more useful object using
   * a variety of helper methods. These helper methods are specific for the type of
   * computation you ran and can be found in the corresponding packages.
   * Please check out the SDK tutorials to see how these results should be handled.
   *
   * @param jobId - Identifier object of the job that has been created when using
   *   [[`Session.runComputation`]].
   */
  getComputationResult(s, { interval: r = 5, timeout: o = void 0 } = {}) {
    const n = R.util.binary.hex.decode(s.jobId);
    let i, e;
    const t = () => {
      clearInterval(e), i !== void 0 && clearTimeout(i);
    };
    return new Promise((l, d) => {
      e = setInterval(() => {
        this.getComputationStatus(s.jobId).then(
          (p) => {
            const u = p.completeComputeNodeIds;
            u && u.includes(s.computeNodeId) && this.getJobResults(n, s.computeNodeId).then(
              (h) => l(h),
              (h) => d(h)
            );
          },
          (p) => d(p)
        );
      }, r * 1e3), o !== void 0 && (i = setTimeout(() => {
        d(
          new Error(
            `Getting computation results timed out after ${o} seconds`
          )
        );
      }, o * 1e3));
    }).finally(t);
  }
  /**
   * Wait for the given job to complete and retrieve its results size.
   *
   * The method will check for the job's completeness every 5 seconds and up to
   * an optional maximum duration after which the method will raise an exception.
   * These values can be specified using the argument of type
   * [[`GetComputationResultsOptions`]].
   *
   * If the job completes and the results can be retrieved successfully, the results
   * size will be returned.
   *
   * @param jobId - Identifier object of the job that has been created when using
   *   [[`Session.runComputation`]].
   */
  getComputationResultSize(s, { interval: r = 5, timeout: o = void 0 } = {}) {
    const n = R.util.binary.hex.decode(s.jobId);
    let i, e;
    const t = () => {
      clearInterval(e), i !== void 0 && clearTimeout(i);
    };
    return new Promise((l, d) => {
      e = setInterval(() => {
        this.getComputationStatus(s.jobId).then(
          (p) => {
            const u = p.completeComputeNodeIds;
            u && u.includes(s.computeNodeId) && this.getJobResultsSize(n, s.computeNodeId).then(
              (h) => l(h),
              (h) => d(h)
            );
          },
          (p) => d(p)
        );
      }, r * 1e3), o !== void 0 && (i = setTimeout(() => {
        d(
          new Error(
            `Getting computation results timed out after ${o} seconds`
          )
        );
      }, o * 1e3));
    }).finally(t);
  }
  /**
   * Run a specific computation and return its results.
   *
   * This method is simply a wrapper for running [[`Session.runComputation`]] and
   * [[`Session.getComputationResult`]] directly after each other.
   */
  async runComputationAndGetResults(s, r, o = {}) {
    const n = await this.runComputation(s, r);
    return this.getComputationResult(n, o);
  }
  /**
   *
   */
  async retrieveUsedAirlockQuotas(s) {
    const r = [6], o = m(this.clientProtocols, r), n = R.util.binary.hex.decode(s), i = c.GcgRequest.create({
      retrieveUsedAirlockQuotaRequest: {
        dataRoomId: n
      }
    }), e = await this.sendRequest(i, o);
    if (e.length !== 1)
      throw new Error("Malformed response");
    const t = e[0], a = t.retrieveUsedAirlockQuotaResponse?.airlockQuotas ?? void 0;
    if (t.gcgResponse !== "retrieveUsedAirlockQuotaResponse" || a === void 0)
      throw new Error(`Request failed, got ${JSON.stringify(t)}`);
    const l = /* @__PURE__ */ new Map();
    for (const d of a) {
      if (d.airlockNodeId === null || d.airlockNodeId === void 0)
        throw new Error(
          `Invalid airlock quota response: ${JSON.stringify(d)}`
        );
      l.set(d.airlockNodeId, {
        limit: d.quotaBytes ?? 0,
        used: d.usedQuotaBytes ?? 0
      });
    }
    return l;
  }
  async sendMediaRequest(s) {
    const r = Math.max(...this.clientProtocols);
    return await this.channel.sendCompilableRequest(
      (o, n) => {
        const i = n.getUserAuth(this.auth), e = c.UserAuth.encodeDelimited(i).finish();
        return this.compiler.compileMediaRequest(
          o,
          e
        );
      },
      s,
      (o) => {
        if (o.length != 1)
          throw new Error("Malformed response");
        return this.compiler.decompileMediaResponse(s, o[0]);
      },
      r
    );
  }
  async sendLookalikeMediaRequest(s) {
    const r = Math.max(...this.clientProtocols);
    return await this.channel.sendCompilableRequest(
      (o, n) => {
        const i = n.getUserAuth(this.auth), e = c.UserAuth.encodeDelimited(i).finish();
        return this.compiler.lookalikeMedia.compileRequest(
          o,
          e
        );
      },
      s,
      (o) => {
        if (o.length != 1)
          throw new Error("Malformed response");
        return this.compiler.lookalikeMedia.decompileResponse(
          s,
          o[0]
        );
      },
      r
    );
  }
  async sendMediaInsightsRequest(s) {
    const r = Math.max(...this.clientProtocols);
    return await this.channel.sendCompilableRequest(
      (o, n) => {
        const i = n.getUserAuth(this.auth), e = c.UserAuth.encodeDelimited(i).finish();
        return this.compiler.mediaInsights.compileRequest(
          o,
          e
        );
      },
      s,
      (o) => {
        if (o.length != 1)
          throw new Error("Malformed response");
        return this.compiler.mediaInsights.decompileResponse(
          s,
          o[0]
        );
      },
      r
    );
  }
  async sendAbMediaRequest(s) {
    const r = Math.max(...this.clientProtocols);
    return await this.channel.sendCompilableRequest(
      (o, n) => {
        const i = n.getUserAuth(this.auth), e = c.UserAuth.encodeDelimited(i).finish();
        return this.compiler.abMedia.compileRequest(
          o,
          e
        );
      },
      s,
      (o) => {
        if (o.length != 1)
          throw new Error("Malformed response");
        return this.compiler.abMedia.decompileResponse(s, o[0]);
      },
      r
    );
  }
  sendRequest(s, r) {
    return this.channel.sendRequest(s, r, this.auth);
  }
}
export {
  T as L,
  y as S,
  O as a
};
//# sourceMappingURL=session-DyDHabUm.js.map
